import {otherRouter, appRouter} from '@/router/router';
import router from '@/router'
import Util from '@/libs/util.js'
import {Message} from 'iview'


const app = {
  state: {
    menuTheme: 'dark',   // 主题色
    options: {
      tableSize: localStorage.tableSize ? localStorage.tableSize : 'default',
      pageSize: localStorage.pageSize ? parseInt(localStorage.pageSize) : 10,
    },
    menuList: [],        // 菜单列表
    themeColor: '',      //
    openedSubmenuArr: [], // 要展开的菜单数组
    currentPath: [
      {
        title: '首页',
        menuList: [],
        path: '',
        name: 'home_index',
      }
    ], // 面包屑数组
    routers: [
      otherRouter,
      ...appRouter
    ],
    setCurrentPageName: '',  // 当前页面title
    
    pageOpenedList: [{
      title: '首页',
      path: '',
      name: 'home_index'
    }],                                    // 当前以及打开页面列表(默认首页)
    tagsList: [...otherRouter.children],   // 所有页面列表
    dontCache: ['home', 'echarts'],                   // 在这里定义你不想要缓存的页面的name属性值(参见路由配置router.js)
    cachePage: [], // 缓存页面
  },
  mutations: {
    // 将所有的路径传入tagsList(包括appRouter)
    setTagsList(state, list) {
      state.tagsList.push(...list);
    },
    // 设置当前面包屑路径
    setCurrentPath(state, pathArr) {
      state.currentPath = pathArr;
    },
    // 更新菜单列表
    updateMenulist(state, val) {
      if (val) {
        state.menuList = val;
      } else {
        if (localStorage.getItem('manageList')) {
          state.menuList = JSON.parse(localStorage.getItem('manageList'));
        }else {
          Message.error('请重新登录');
          router.push('/login');
        }
      }
    },
    // 保存用户头像路径
    setAvator(state, path) {
      localStorage.avatorImgPath = path;
    },
    // 当前打开列表
    pageOpenedList(state, get) {
      console.log(get);
      let openedPage = state.pageOpenedList[get.index];
      if (get.argu) {
        openedPage.argu = get.argu;
      }
      if (get.query) {
        openedPage.query = get.query;
      }
      state.pageOpenedList.splice(get.index, 1, openedPage);
      localStorage.pageOpenedList = JSON.stringify(state.pageOpenedList);
    },
    // 判断当前是否需要创建新的tag || 跳转到已有tag上
    increateTag(state, tagObj) {
      if (!Util.oneOf(tagObj.name, state.dontCache)) {
        state.cachePage.push(tagObj.name);
        localStorage.cachePage = JSON.stringify(state.cachePage);
      }
      
      state.pageOpenedList.push(tagObj);
      localStorage.pageOpenedList = JSON.stringify(state.pageOpenedList);
    },
    // 关闭特定tag
    closeTag(state, name) {
      state.pageOpenedList.forEach((val, ind) => {
        if (val.name === name) {
          state.pageOpenedList.splice(ind, 1);
        }
      });
      router.go(-1);
    },
    // 设置当前页面title
    setCurrentPageName(state, name) {
      state.currentPageName = name;
    },
    // 清除所有tags(留一个首页)
    clearAllTags(state) {
      state.pageOpenedList.splice(1);
      state.cachePage.length = 0;
      localStorage.pageOpenedList = JSON.stringify(state.pageOpenedList);
    },
    // 清除其他tags
    clearOtherTags(state, vm) {
      let currentName = vm.$route.name;
      let currentIndex = 0;
      state.pageOpenedList.forEach((item, index) => {
        if (item.name === currentName) {
          currentIndex = index;
        }
      });
      if (currentIndex === 0) {
        state.pageOpenedList.splice(1);
      } else {
        state.pageOpenedList.splice(currentIndex + 1);
        state.pageOpenedList.splice(1, currentIndex - 1);
      }
      let newCachepage = state.cachePage.filter(item => {
        return item === currentName;
      });
      state.cachePage = newCachepage;
      localStorage.pageOpenedList = JSON.stringify(state.pageOpenedList);
    },
    // 添加
    addOpenSubmenu(state, name) {
      let hasThisName = false;
      let isEmpty = false;
      if (name.length === 0) {
        isEmpty = true;
      }
      if (state.openedSubmenuArr.indexOf(name) > -1) {
        hasThisName = true;
      }
      if (!hasThisName && !isEmpty) {
        state.openedSubmenuArr.push(name);
      }
    },
    // 移除当前Tag
    removeTag(state, name) {
      state.pageOpenedList.map((item, index) => {
        if (item.name === name) {
          state.pageOpenedList.splice(index, 1);
        }
      });
    },
    // 将页面从缓存中去除
    closePage(state, name) {
      state.cachePage.forEach((item, index) => {
        if (item === name) {
          state.cachePage.splice(index, 1);
        }
      });
    },
    // 从缓存中获取已打开页面
    setOpenedList(state) {
      state.pageOpenedList = localStorage.pageOpenedList ? JSON.parse(localStorage.pageOpenedList) : [otherRouter.children[0]];
    },
    // 清除
    clearOpenedSubmenu(state) {
      state.openedSubmenuArr.length = 0;
    },
    // 修改菜单(左侧)主题
    changeMenuTheme(state, theme) {
      state.menuTheme = theme;
    },
    // 修改主色调
    changeMainTheme(state, mainTheme) {
      state.themeColor = mainTheme;
    },
    // 更新table尺寸
    updateTableSize(state, size) {
      state.options.tableSize = size;
    },
    // 更新页码大小
    updatePageSize(state, size) {
      state.options.pageSize = parseInt(size);
    }
  }
};

export default app;



// WEBPACK FOOTER //
// ./src/store/modules/app.js